export const envMap = {
  'test': 'test', // 测试环境
  'mdemo': 'prod', // 演示环境
  'erp': 'production', // 生产环境
  'dev': 'dev'
}
/**
 * @description 获取系统环境
 */
export const useVirtualEnv = () => {
  let hostname = window.location.hostname;
  return envMap[hostname.split('.')[0]]
}

/**
 * @description 设置sentry 版本
 */
export const sentryRelease = (version) => {
  let env = useVirtualEnv();
  return `${env}_${version}`
}